"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityUpdateQuery = void 0;
var client_1 = require("@apollo/client");
var graphql_1 = require("./graphql");
var entityUpdateQuery = function (definition, context) {
  var q = (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query ", "UpdateQuery($id: ID!) {\n      ", "(id: $id) {\n        id\n        slug\n        name\n        isDeletable\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n      }\n    }\n  "], ["\n    query ", "UpdateQuery($id: ID!) {\n      ", "(id: $id) {\n        id\n        slug\n        name\n        isDeletable\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n      }\n    }\n  "])), definition.typeName, definition.updateTypeName, definition.useCreator ? "\n          createdBy { ...CreatorFields }\n          updatedBy { ...CreatorFields }\n          created\n          updated\n        " : '', definition.usePublishStatus ? 'publishStatus { id name slug }' : '', definition.usePermissions ? "permissions { ...PermissionsFields }" : '', definition.useVisibility ? 'visibility { id name slug }' : '', definition.useModerators ? 'moderators { id name slug openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } } }' : '', definition.update.queryFields || '');
  return (0, client_1.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), q);
};
exports.entityUpdateQuery = entityUpdateQuery;
var templateObject_1, templateObject_2;